// Generated by purs version 0.15.0
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Utils_Progress from "../Utils.Progress/index.js";
var showProgress = function (dictMonadFRP) {
    return Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(function (v) {
        if (v instanceof Data_Maybe.Just) {
            return Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(Utils_Progress.showProgress(v.value0));
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(Utils_Progress.hideProgress);
        };
        throw new Error("Failed pattern match at Restaumatic.Progress (line 25, column 7 - line 27, column 46): " + [ v.constructor.name ]);
    });
};
export {
    showProgress
};
//# sourceMappingURL=index.js.map
